import { createAction } from 'redux-actions';

const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export default function language(state = 'en-US', action = null) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return action.payload;
    default:
      return state;
  }
}

export const changeLanguage = (query) => {
  return (dispatch) => {
    const action = createAction(CHANGE_LANGUAGE)(query);
    dispatch(action);
  };
};
